import { noop } from 'lodash';
import PropTypes from 'prop-types';

export const GlobalSearchLinkPropTypes = {
  query: PropTypes.string,
  creativeId: PropTypes.string,
  isMobile: PropTypes.bool,
  fastMatcherData: PropTypes.shape({
    delta: PropTypes.string,
    struct: PropTypes.shape({}),
  }),
  onLinkClick: PropTypes.func,
  url: PropTypes.string,
  selectionType: PropTypes.string,
  title: PropTypes.string,
  rel: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  linkType: PropTypes.string,
};
export const GlobalSearchLinkDefaultProps = {
  query: '',
  creativeId: '',
  isMobile: false,
  onLinkClick: noop,
  url: '',
  selectionType: '',
  title: '',
  rel: undefined,
  fastMatcherData: undefined,
  icon: undefined,
  label: undefined,
  linkType: undefined,
};
